<template lang="pug">
    div.row(v-if="isEftDetails")
        .col-md-12
            small.dark.block.text-center.m-y-sm EFT Details

        template(v-if="isBhpEnvironment")
          .col-md-12
            .col-md-12.col-flex
              .col-md-6
                  table.m-b-0
                      tbody
                          tr(v-if="eftDetails.details.card_desc")
                            td.text-bold Card Desc
                            td.text-right-small {{ eftDetails.details.card_desc }}
                          tr(v-if="eftDetails.details.site_id")
                            td.text-bold Site Id
                            td.text-right-small {{ eftDetails.details.site_id }}
                          tr(v-if="eftDetails.details.pos_stan")
                            td.text-bold POS STAN
                            td.text-right-small {{ eftDetails.details.pos_stan }}
                          tr(v-if="eftDetails.details.ref")
                            td.text-bold Ref
                            td.text-right-small {{ eftDetails.details.ref }}
                          tr(v-if="eftDetails.details.card")
                            td.text-bold Card
                            td.text-right-small {{ eftDetails.details.card }}
                          tr(v-if="eftDetails.details.driver_card")
                            td.text-bold Driver Card
                            td.text-right-small {{ eftDetails.details.driver_card }}
                          tr(v-if="eftDetails.details.vehicle_card")
                            td.text-bold Vehicle Card
                            td.text-right-small {{ eftDetails.details.vehicle_card }}
                          tr(v-if="eftDetails.details.preauth && !eftDetails.details.driver_card && !eftDetails.details.vehicle_card")
                            td.text-bold Preauth
                            td.text-right-small {{ eftDetails.details.preauth }}
                          tr(v-if="eftDetails.details.verification")
                            td.text-bold Verification
                            td.text-right-small {{ eftDetails.details.verification }} {{ eftDetails.details.receipt_line_1 }}
                          tr(v-if="eftDetails.details.ac_type")
                            td.text-bold AC Type
                            td.text-right-small {{ eftDetails.details.ac_type }}
                          tr(v-if="eftDetails.details.fi_approval_code")
                            td.text-bold FI Approval Code
                            td.text-right-small {{ eftDetails.details.fi_approval_code }}
                          tr(v-if="eftDetails.details.fi_mid")
                            td.text-bold FI MID
                            td.text-right-small {{ eftDetails.details.fi_mid }}
                          tr(v-if="eftDetails.details.tc")
                            td.text-bold TC
                            td.text-right-small {{ eftDetails.details.tc }}
                          tr(v-if="eftDetails.details.app_id")
                            td.text-bold App ID
                            td.text-right-small {{ eftDetails.details.app_id }}
              .vertical-line
              .col-md-6
                  table.m-b-0
                      tbody
                          tr(v-if="eftDetails.details.terminal")
                            td.text-bold Terminal
                            td.text-right-small {{ eftDetails.details.terminal }}
                          tr(v-if="eftDetails.details.site_tran_no")
                            td.text-bold Site Tran No
                            td.text-right-small {{ eftDetails.details.site_tran_no }}
                          tr(v-if="eftDetails.details.invoice_no")
                            td.text-bold Invoice No
                            td.text-right-small {{ eftDetails.details.invoice_no }}
                          tr(v-if="eftDetails.details.auth_id")
                            td.text-bold Auth ID
                            td.text-right-small {{ eftDetails.details.auth_id }}
                          tr(v-if="eftDetails.details.card_exp")
                            td.text-bold Card Exp
                            td.text-right-small {{ eftDetails.details.card_exp }}
                          tr(v-if="eftDetails.details.preauth && eftDetails.details.driver_card && eftDetails.details.vehicle_card")
                            td.text-bold Preauth
                            td.text-right-small {{ eftDetails.details.preauth }}
                          tr(v-if="eftDetails.details.odometer")
                            td.text-bold Odometer
                            td.text-right-small {{ eftDetails.details.odometer }}
                          tr(v-if="eftDetails.details.entry_mode")
                            td.text-bold Entry Mode
                            td.text-right-small {{ eftDetails.details.entry_mode }}
                          tr(v-if="eftDetails.details.fi_tid")
                            td.text-bold FI TID
                            td.text-right-small {{ eftDetails.details.fi_tid }}
                          tr(v-if="eftDetails.details.fi_trace_no")
                            td.text-bold FI Trace No
                            td.text-right-small {{ eftDetails.details.fi_trace_no }}
                          tr(v-if="eftDetails.details.app")
                            td.text-bold App
                            td.text-right-small {{ eftDetails.details.app }}

        template(v-else)
          .col-md-12
            .col-md-12.col-flex
              .col-md-6
                  table.m-b-0.small-text-table
                      tbody
                          tr(v-if="eftDetails.details.card_name")
                            td.text-bold Card Name
                            td.text-right-small {{ eftDetails.details.card_name }}
                          tr(v-if="eftDetails.details.terminal")
                            td.text-bold Terminal
                            td.text-right-small {{ eftDetails.details.terminal }}
                          tr(v-if="eftDetails.details.site_id")
                            td.text-bold Site ID
                            td.text-right-small {{ eftDetails.details.site_id }}
                          tr(v-if="eftDetails.details.site_tran_no")
                            td.text-bold Site Tran No
                            td.text-right-small {{ eftDetails.details.site_tran_no }}
                          tr(v-if="eftDetails.details.reference_no")
                            td.text-bold Reference No.
                            td.text-right-small {{ eftDetails.details.reference_no }}
                          tr(v-if="eftDetails.details.receipt_no")
                            td.text-bold Receipt No.
                            td.text-right-small {{ eftDetails.details.receipt_no }}
                          tr(v-if="eftDetails.details.batch_no")
                            td.text-bold Batch No
                            td.text-right-small {{ eftDetails.details.batch_no }}
                          tr(v-if="eftDetails.details.entry_mode")
                            td.text-bold Entry Mode
                            td.text-right-small {{ eftDetails.details.entry_mode }}
              .vertical-line
              .col-md-6
                  table.m-b-0
                      tbody
                          tr(v-if="eftDetails.details.card")
                            td.text-bold Card
                            td.text-right-small {{ eftDetails.details.card }}
                          tr(v-if="eftDetails.details.app")
                            td.text-bold App
                            td.text-right-small {{ eftDetails.details.app }}
                          tr(v-if="eftDetails.details.seq__number")
                            td.text-bold Seq. Number
                            td.text-right-small {{ eftDetails.details.seq__number }}
                          tr(v-if="eftDetails.details.app_id")
                            td.text-bold App ID
                            td.text-right-small {{ eftDetails.details.app_id }}
                          tr(v-if="eftDetails.details.app_crypt")
                            td.text-bold App Crypt
                            td.text-right-small {{ eftDetails.details.app_crypt }}
                          tr(v-if="eftDetails.details.odometer")
                            td.text-bold Odometer
                            td.text-right-small {{ eftDetails.details.odometer }}
                          tr(v-if="eftDetails.details.skdsname")
                            td.text-bold SKDS/Name
                            td.text-right-small {{ eftDetails.details.skdsname }}
                          tr(v-if="eftDetails.details.auth_code")
                            td.text-bold Auth Code
                            td.text-right-small {{ eftDetails.details.auth_code }}
                          tr(v-if="eftDetails.details.verification")
                            td.text-bold Verification
                            td.text-right-small {{ eftDetails.details.verification }} {{ eftDetails.details.receipt_line_1 }}
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transactionPostgres', ['eftDetails']),

        isBhpEnvironment() {
            return Auth.metas().environment === 'bhp';
        },

        isEftDetails() {
            return _.isObject(this.eftDetails);
        },
    },
};
</script>

<style lang="scss" scoped>
table {
    width: 100%;
}

table tr td {
    vertical-align: top !important;
}

.col-flex {
    display: flex;
    border: 2px solid #000;
    padding: 10px;
    border-radius: 10px;
}

.text-bold {
    font-weight: bold;
    font-size: 90%;
}

.text-right-small {
    font-size: 90%;
    text-align: right;
    max-width: 150px;
}

.small-text {
    font-size: 90%;
}

.vertical-line {
    width: 1px; /* Adjust the thickness of the line */
    background-color: #000; /* Adjust the color of the line */
    margin: 0 10px; /* Adjust the spacing around the line */
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt-postgres/receipt-eft-details.vue